export enum RPCMethod {
  SWITCH_CHAIN = "wallet_switchEthereumChain",
  ADD_CHAIN = "wallet_addEthereumChain",
}
